import React from 'react';
import logo from './stratego.png';
import { NavLink } from 'react-router-dom';
import { Popup } from 'semantic-ui-react';

export default function Logo() {
    return (
        <NavLink exact to='/'>
            <Popup trigger={
                <img src={logo} alt='Logo' width="45%"/>
                
            }
            position="right center"
            content="Vissza a főoldalra"
            />
        </NavLink>
    );
}
